<template>
    <div class="">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-title" :style="{top:statusHeight+'rem'}">
            <div class="color-333 fs-36">{{countEntity.shopName || userName}}</div>
            <div class="flex-center">
                <div class="right-icon alifont icon-refresh click mr-20" @click="refreshOrderCount"></div>
                <div class="right-icon alifont icon-xiaoxi click"  @click="$router.push({name: 'messageList'})"></div>
            </div>
        </div>
        <div class="pd-025">
            <div class="main-content" v-if="isCabinetToolBuyerRole">
                <div class="opc"></div>
                <div class="flex-center" style="position: relative;z-index: 10">
                    <div class="flex1 text-center">
                        <div class="fs-28 color-fff">今天取货数</div>
                        <div class="sale-money number_font click">{{formatNumber(countEntity.todayNum / 1000 || 0) }} <span class="fs-40">kg</span></div>
                    </div>
                    <div class="flex1 text-center">
                        <div class="fs-28 color-fff">总取货数</div>
                        <div class="sale-money number_font click">{{formatNumber(countEntity.totalNum / 1000 || 0) }} <span class="fs-40">kg</span></div>
                    </div>
                </div>
            </div>
            <div class="com-content">
                <div class="fs-36 color-333 font-bold">管理</div>
                <div class="content-list" >
                    <div class="content-item click" v-for="(item,$index) in manageList" :key="$index" @click="goUrl(item)">
                        <img :src="item.img" alt="">
                        <div class="fs-28 color-333 mt-10">{{item.name}}</div>
                    </div>
                </div>
            </div>
            <div class="com-content">
                <div class="fs-36 color-333 font-bold">设置</div>
                <div class="content-list" >
                    <div class="content-item click" v-for="(item,$index) in settingList" :key="$index" @click="goUrl(item)">
                        <img :src="item.img" alt="">
                        <div class="fs-28 color-333 mt-10">{{item.name}}</div>
                    </div>
                </div>
            </div>
        </div>
        <img :src="scanImg" alt="" class="scan-img click"  @click="scan">
    </div>
</template>
<script>
    import {openDoorForAdmin} from "@/api/shop"
    import {qryStockLogPickUpCount} from "@/api/product"
    import {isURL,parseUrl,getToken} from "@/utils/util"
    import supplyRecordList from "@/view/supplyRecord/list"
    import {mapActions} from 'vuex'
    import config from "@/config"
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    import getAppParams from "@/mixins/getAppParams"
    export default {
        name: 'Home',
        components:{supplyRecordList,appStatus},
        mixins:[getAppStatusHeight,getAppParams],
        computed:{
            'manageList':function(){
                if(this.isCabinetToolBuyerRole){
                    return  [
                        {name:'取货记录',img:require("../assets/images/shopHome/tag15.png"),url:'supplyRecordList'},
                    ]
                }else if(this.isCabinetToolSupplyRole){
                    return  [
                        {name:'补货记录',img:require("../assets/images/shopHome/tag15.png"),url:'supplyRecordList'},
                        {name:'我的柜子',img:require("../assets/images/shopHome/tag16.png"),url:'equipmentList'},
                        {name:'缺货柜子',img:require("../assets/images/shopHome/tag13.png"),url:'disStockCabinet'},
                    ]
                }else{
                    return []
                }

            }
        },
        data() {
            return {
                userName:this.$store.state.user.userName,
                isCabinetToolBuyerRole: this.$store.state.user.isCabinetToolBuyerRole || false,
                isCabinetToolSupplyRole: this.$store.state.user.isCabinetToolSupplyRole || false,
                aliasName:this.$store.state.aliasName || config.projectName,
                scanImg: require("../assets/images/shopHome/scan.png"),
                countEntity:{},


                settingList:[
                    {name:'个人中心',img:require("../assets/images/shopHome/tag9.png"),url:'userCenter',isToApp:true,appMethod:'toMine'},
                    // {name:'联系客服',img:require("../assets/images/shopHome/tag10.png"),url:'contact'},
                ],
            }
        },
        created() {
            this.getUserInfoFun();
            this.getCounts();
        },
        activated(){

        },
        mounted() {

        },
        methods: {
            ...mapActions([
                'getUserInfo'
            ]),
            scan(){
                let projectName = this.aliasName;
                try{
                    let _this = this;
                    let type = this.isCabinetToolBuyerRole ? 0 : 1;
                    u.native.scanMulti(type,function (respon) {
                        console.log(respon)
                        if(respon){
                            let result = JSON.parse(respon);
                            if(result.data && result.data.result){
                                let bol = isURL(result.data.result);     //是否是url链接
                                if(bol){
                                    let params = parseUrl(result.data.result);
                                    _this.eqShopId = params.shopId;
                                    _this.otype = params.otype || 'buy';
                                    _this.eqType = params.equipmentType || 'rfid';
                                    if(result.data.type == 1 || result.data.type == 0){
                                        if(_this.otype == 'buy'){
                                            let requestPar = {
                                                accessToken:getToken(),
                                                shopId:_this.eqShopId,
                                            }
                                            openDoorForAdmin(requestPar).then(res=>{
                                                if(res.code == 0){
                                                    _this.$toast("开门成功");
                                                    if(_this.eqType == 'weigh'){
                                                        _this.$router.push({name:'supplyCompare',query:{shopId: _this.eqShopId}})
                                                    }
                                                }

                                            })
                                        }else if(_this.otype == 'locker'){
                                            _this.$router.push({name:'lockerCargoList',query:{shopId: _this.eqShopId}})
                                        }
                                    }else{
                                        _this.$router.push({name:'equipmentHome',query:{shopId: _this.eqShopId}})
                                    }

                                }else{
                                    _this.$toast("请扫描柜子二维码");
                                }
                            }
                        }
                    })


                }catch (e) {

                    this.$toast('请在App上操作'+e);

                    // let _this = this;
                    // let result = '675367552838270976'
                    // if(String(result) == Number(result)){
                    //     _this.$router.push({name:'orderDetail',query:{orderId: result,isScan:true}})
                    // }else{
                    //     _this.$toast('请扫描待核销订单二维码');
                    // }

                }
            },
            goUrl(data){
                if(data && !data.isToApp){
                    this.$router.push({name: data.url});
                }else if(data && data.isToApp){
                    try{
                        window.native[data.appMethod]()
                    }catch (e) {
                        if(data.url){
                            this.$router.push({name: data.url});
                        }
                    }
                }
            },
            getUserInfoFun(){
                try {
                    window.native.getApp();
                    this.getUserInfo().then(res => {
                        this.isCabinetToolSupplyRole = res.isCabinetToolSupplyRole;
                        this.isCabinetToolBuyerRole = res.isCabinetToolBuyerRole;
                        console.log(this.isCabinetToolBuyerRole)
                    }).finally(() =>{
                        // this.loadState = 'finish';
                    })
                }catch (e) {

                }
            },
            refreshOrderCount(){
                this.getCounts();
            },
            getCounts(){
                qryStockLogPickUpCount({}).then(res=>{
                    if (res.code === 0) {
                        this.countEntity = res.data;
                    }
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .page{
        padding-bottom: 1.2rem;
    }
    .page-title{
        width: 100%;
        padding: .25rem;
        display: flex;
        background: #fff;
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        left: 0;
        z-index: 200;
        justify-content: space-between;
        align-items: center;
        .right-icon{
            font-size: .48rem;
        }
    }
    .main-content{
        width: 100%;
        border-radius: .12rem;
        background: $main-color;
        padding: .34rem .36rem .28rem;
        position: relative;
        .sale-money{
            font-size: .62rem;
            line-height: .76rem;
            color: #fff;
            margin-top: .04rem;
        }
        .opc{
            position: absolute;
            width:6.6rem;
            height: .5rem;
            background: $main-color;
            border-radius: .12rem;
            opacity:0.64;
            filter:blur(.1rem);
            left: .2rem;
            bottom: -.07rem;
        }
    }
    .scan-img{
        width: 2.46rem;
        height: .95rem;
        position: fixed;
        bottom: 0;
        left: 50%;
        margin-left: -1.23rem;
    }
    .opc-08{
        opacity: .8;
    }
    .com-content{
        margin-top: .63rem;
        .content-list{
            display: flex;
            flex-wrap: wrap;
        }
        .content-item{
            width: 33.3333%;
            text-align: center;
            margin-top: .35rem;
            img{
                width: .96rem;
                height: .96rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// homeByToolCabinet.vue?3ee636cf